import { render, staticRenderFns } from "./NotImplementedComponent.vue?vue&type=template&id=4ff31801&scoped=true&"
import script from "./NotImplementedComponent.vue?vue&type=script&lang=ts&"
export * from "./NotImplementedComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff31801",
  null
  
)

export default component.exports